import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { SupervisorBooking } from './supervisor-booking'
import { supervisorBookingActions } from './supervisor-booking.actions'
import * as fromSupervisorBooking from './supervisor-booking.reducer'
import { SupervisorBookingService } from './supervisor-booking.service'
import { exhaustMap, map } from 'rxjs/operators'
import { normalizeToSchema } from 'src/app/shared/normalization/normalization'
import { normalizationActions } from 'src/app/shared/normalization/normalization.actions'

@Injectable()
export class SupervisorBookingEffects extends ResourceEffects<SupervisorBooking> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    private supervisorBookingService: SupervisorBookingService
  ) {
    super(
      fromSupervisorBooking.FEATURE_NAME,
      supervisorBookingService,
      supervisorBookingActions,
      actions$
    )
  }
}
